import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { error: Error | null }

/** Последний рубеж: любая ошибка рендера превращается в понятный экран, а не в белый. */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Ошибка интерфейса', error, info.componentStack)
  }

  override render(): ReactNode {
    const { error } = this.state
    if (!error) return this.props.children
    return (
      <div className="page">
        <div className="empty">
          <h1 style={{ marginBottom: 8 }}>Что-то сломалось</h1>
          <p className="faint" style={{ wordBreak: 'break-word' }}>
            {error.message}
          </p>
          <div className="row" style={{ justifyContent: 'center', marginTop: 12 }}>
            <button type="button" onClick={() => this.setState({ error: null })}>
              Попробовать снова
            </button>
            <button type="button" className="ghost" onClick={() => location.reload()}>
              Перезагрузить страницу
            </button>
          </div>
        </div>
      </div>
    )
  }
}
